var url = process.env.API_URL + process.env.API_VERSION;
import axios from 'axios';
import cookie from 'vue-cookie';
import router from '../../router';
const state = {
  counselor_appointments: [],
  pagination_counselor_appointment: {},
  customer_appointments: [],
  pagination_customer_appointment: {},
  appointment_detail: {},
}
const mutations = {
  update_counselor_appointment(state, data){
    state.counselor_appointments = data.appointments    
    state.pagination_counselor_appointment = data.pagination
  },
  update_customer_appointment(state, data){
    state.customer_appointments = data.appointments
    state.pagination_customer_appointment = data.pagination
  },
  set_detail_appointment(state, data){
    state.appointment_detail = data.appointment
  },
}
const actions = {
  get_counselor_appointment({commit}, page){
    axios.get(url + '/appointment/my_appointment_be_customer?page=' + page,
      {
        headers: {
          'Authorization': cookie.get('user-token') || ''
        }
      }
    )
    .then((response) => {
      commit('update_counselor_appointment', response.data.extra)
    })
    .catch((error) => {
      if (error.response != undefined){
        alert(error.response.data.message)
      }
    })
  },
  get_customer_appointment({commit}, page){
    axios.get(url + '/appointment/my_appointment?page=' + page,
      {
        headers: {
          'Authorization': cookie.get('user-token') || ''
        }
      }
    )
    .then((response) => {
      commit('update_customer_appointment', response.data.extra)
    })
    .catch((error) => {
      if (error.response != undefined){
        alert(error.response.data.message)
      }
    })
  },
  get_appointment({commit}, id){
    axios.get(url + "/appointment/detail?id=" + id,
    {
      headers:{
        'Authorization': cookie.get('user-token') || ''
      }
    })
    .then((response) => {
      commit('set_detail_appointment', response.data.extra)
    })
    .catch((error) => {
      if (error.response != undefined) {
        alert(error.response.data.message)
      }
    })
  },
}
const getters = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vuex_appointment.js